export const APP_STARTED = "APP_STARTED";

export const appStarted = () => ({
  type: APP_STARTED,
});
